import * as React from "react";
import ReactTable from "react-table";
import { MoraNotas, FiltroConsultarEnvioMora } from "../modelo/EnviosMoraModelo";
import { ModalDetalleJson } from "../../config_general/componentes/ModalDetalleJson";

export default class TablaMoraNotas extends React.Component<TablaMoraNotasProps, any> {

    columns = [
        {
            id: "dni",
            Header: "Documento",
            accessor: "dni",
            width: 110
        },
        {
            id: "poliza",
            Header: "Poliza",
            accessor: "poliza",
            width: 110
        },
        {
            id: "periodo",
            Header: "Periodo",
            accessor: "periodo",
            width: 110
        },
        {
            id: "detalleMarca",
            Header: "Detalle Marca",
            accessor: "jsonMensajeMarca",
            Cell: props => (this.renderDetalleJson(props, props.original.jsonMensajeMarca)),
            width: 130
        },
        {
            id: "fechaEnvioSAT",
            Header: "Fecha Envio",
            accessor: "fechaEnvioSAT",
            width: 130
        },
        {
            id: "detalleDesmarca",
            Header: "Detalle Desmarca",
            accessor: "jsonMensajeDesmarca",
            Cell: props => (this.renderDetalleJson(props, props.original.jsonMensajeDesmarca)),
            width: 130
        },
        {
            id: "fechaDesmarcaSAT",
            Header: "Fecha Desmarca",
            accessor: "fechaDesmarcaSAT",
            width: 130
        },
        {
            id: "tipoMora",
            Header: "Tipo Mora",
            accessor: "tipoMora",
            width: 130
        },
        {
            id: "tipoRegistro",
            Header: "Tipo Envio",
            accessor: "tipoRegistro",
            width: 120
        }
    ];

    constructor(props: any) {
        super(props);

        this.state = {};
    }

    render() {
        const { moraNotas, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (moraNotas.length < tamanoPagina) {
            numRegistros = moraNotas.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{moraNotas.length}</span> Envio Mora encontrados
                    </h2>
                </div>
                <ReactTable data={moraNotas}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroConsultarEnvioMora = {
            dniEmpleador: this.props.filtro.dniEmpleador,
            poliza: this.props.filtro.poliza,
            consecutivo: this.props.filtro.consecutivo,
            tipoFecha: this.props.filtro.tipoFecha,
            fecha: this.props.filtro.fecha,
            complementoFecha: this.props.filtro.complementoFecha,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderDetalleJson = (props: any, stringJson: string) => {
        const subTitulo = `Poliza: ${props.original.poliza}`;
        const titulo = 'Detalle Respuesta SAT';
        return (
            <div style={{ marginTop: '5px' }}>
                <ModalDetalleJson
                    titulo={titulo}
                    subTitulo={subTitulo}
                    stringJson={stringJson}
                />
            </div>
        );
    }

}

interface TablaMoraNotasProps {
    moraNotas: Array<MoraNotas>
    filtro: FiltroConsultarEnvioMora,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroConsultarEnvioMora) => void
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_envio_mora/componentes/TablaMoraNotas.tsx